import { CHANGE_FILTER, LOAD_MORE_LOGS } from './_actions';

// Log console
export const currentPage = (state = 0, action) => {
  switch (action.type) {
    case LOAD_MORE_LOGS:
      return action.page;
    default:
      return state;
  }
};

// Filters
export const filters = (state = { type: 'any', level: 'any' }, action) => {
  switch (action.type) {
    case CHANGE_FILTER:
      return { ...state, ...action.filter };
    default:
      return state;
  }
};
